module.exports = __webpack_public_path__ + "img/chat.0110d6ec.svg";